export const REQUEST_PRODUCTS_WITH_PRICES = "CATALOG/REQUEST_PRODUCTS_WITH_PRICES";
export const GET_PRODUCT_LIST = "CATALOG/GET_PRODUCT_LIST";
export const ADD_CATALOG_ITEMS = "CATALOG/ADD_CATALOG_ITEMS";
export const SET_LOADING_ITEMS = "CATALOG/SET_LOADING_ITEMS";
export const SET_PAGE_SIZE = "CATALOG/SET_PAGE_SIZE";
export const SET_VIEW_MODE = "CATALOG/SET_VIEW_MODE";
export const SET_PRODUCT_LIST = "CATALOG/SET_PRODUCT_LIST";


export const SET_CATALOG_FILTERS = "CATALOG/SET_CATALOG_FILTERS";